'use client'

import { useEffect } from 'react'
import { useSearchParams } from 'next/navigation'
import { storeReferralCode } from '@/lib/referral_code'

/**
 * Records a referral visit to the server
 */
async function recordReferralVisit(referralCode: string) {
  try {
    await fetch('/api/referral/visit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ referralCode }),
    })
  } catch (error) {
    // Silently fail - we don't want to block the user experience
    console.error('Failed to record referral visit:', error)
  }
}

export function ReferralHandler() {
  const searchParams = useSearchParams()

  useEffect(() => {
    const ref = searchParams.get('ref')
    const via = searchParams.get('via')
    const code = ref || via
    if (code) {
      // Store in localStorage for later use during signup
      storeReferralCode(code)

      // Record the visit to the server
      recordReferralVisit(code)
    }
  }, [searchParams])

  return null
}
